import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const nlTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Naam (kleine letters, geen speciale tekens)',
    add: 'Toevoegen',
    allowedFileTypes: 'Toegestane bestandstypen',
    allowedFileTypesDescription:
      'Beperk toegestane bestandstypen (bijvoorbeeld image/*, application/pdf). Laat leeg om alle typen toe te staan.',
    allowMultipleFiles: 'Meerdere bestanden toestaan',
    amountInCents: 'Bedrag in centen',
    basePrice: 'Basisprijs',
    bcc: 'BCC',
    brand: 'Merk',
    cc: 'CC',
    checkboxPlural: 'Selectievakjesvelden',
    checkboxSingular: 'Selectievakje',
    checkedByDefault: 'Standaard aangevinkt',
    chooseConfirmationType:
      'Kies of u een bericht op de pagina wilt weergeven of wilt doorsturen naar een andere pagina nadat ze het formulier hebben verzonden.',
    condition: 'Conditie',
    confirmationMessage: 'Bevestigingsbericht',
    confirmationType: 'Bevestigingstype',
    countryPlural: 'Landvelden',
    countrySingular: 'Land',
    creditCard: 'Creditcard',
    customURL: 'Aangepaste URL',
    datePlural: 'Datumvelden',
    dateSingular: 'Datum',
    defaultValue: 'Standaardwaarde',
    divide: 'Verdeel',
    documentToLinkTo: 'Document waarnaar moet worden gelinkt',
    doesNotEqual: 'Is niet gelijk',
    emailFrom: 'E-mail van',
    emailPlural: 'E-mailvelden',
    emailsDescription:
      "Stuur aangepaste e-mails wanneer het formulier wordt verzonden. Gebruik door komma's gescheiden lijsten om dezelfde e-mail naar meerdere ontvangers te sturen. Als u naar een waarde uit dit formulier wilt verwijzen, plaatst u de naam van dat veld tussen dubbele accolades, bijvoorbeeld {{firstName}}. U kunt een jokerteken {{*}} gebruiken om alle gegevens uit te voeren en {{*:table}} om deze op te maken als een HTML-tabel in de e-mail.",
    emailSingular: 'E-mail',
    emailTo: 'E-mail naar',
    equals: 'Gelijk aan',
    field: 'Veld',
    fields: 'Velden',
    fieldWidth: 'Veldbreedte (percentage)',
    hasAnyValue: 'Heeft enige waarde',
    internalLink: 'Interne link',
    label: 'Etiket',
    maxFileSize: 'Maximale bestandsgrootte (bytes)',
    maxFileSizeDescription: 'Maximale bestandsgrootte in bytes. Laat leeg voor geen limiet.',
    message: 'Bericht',
    messageDescription: 'Voer het bericht in dat in deze e-mail moet worden verzonden.',
    messagePlural: 'Berichtblokken',
    messageSingular: 'Bericht',
    mimeType: 'MIME-type',
    mimeTypePlural: 'MIME-typen',
    mimeTypeSingular: 'MIME-type',
    multiply: 'Vermenigvuldig',
    numberPlural: 'Nummervelden',
    numberSingular: 'Nummer',
    optionPlural: 'Opties',
    optionSingular: 'Optie',
    paymentFieldPlural: 'Payment Fields',
    paymentFieldSingular: 'Betaling',
    paymentProcessor: 'Betalingsverwerker',
    paymentStatus: 'Status',
    placeholder: 'Tijdelijke aanduiding',
    priceConditions: 'Prijsvoorwaarden',
    priceConditionsPlural: 'Price Conditions',
    priceConditionsSingular: 'Price Condition',
    radioOptions: 'Radio Attribute Options',
    radioPlural: 'Radio Fields',
    radioSingular: 'Radio',
    redirect: 'Omleiden',
    replyTo: 'Antwoord aan',
    required: 'Vereist',
    selectOptions: 'Selecteer Opties',
    selectPlural: 'Selecteer Velden',
    selectSingular: 'Selecteer',
    statePlural: 'State Fields',
    stateSingular: 'Staat',
    staticValue: 'Statische waarde',
    subject: 'Onderwerp',
    submitButton: 'Knoplabel verzenden',
    subtract: 'Aftrekken',
    textareaPlural: 'Tekstveldvelden',
    textareaSingular: 'Tekstgebied',
    textPlural: 'Tekstvelden',
    textSingular: 'Tekst',
    title: 'Titel',
    token: 'teken',
    uploadCollection: 'Verzameling uploaden',
    uploadCollectionDescription: 'Selecteer in welke uploadcollectie u bestanden wilt opslaan',
    uploadFieldPlural: 'Velden uploaden',
    uploadFieldSingular: 'Uploaden',
    urlToRedirectTo: 'URL waarnaar wordt doorverwezen',
    value: 'Waarde',
    valueOfField: 'Waarde van veld',
    valueType: 'Waardetype',
  },
}

export const nl: PluginLanguage = {
  dateFNSKey: 'nl',
  translations: nlTranslations,
}
